import env from '@/core/utils/env'
let activity = 'fw_202012'
if (env === 'local') {
  activity = 'fw_2020'
} else if (env === 'testing') {
  activity = 'fw_test_20201119'
} else if (env === 'pre') {
  activity = 'fw_202012_pre'
}
// tl 红包
export const tlRedpack = (id: string) => {
  return `/v1/newsapp/fireworks/${activity}/get_redpack/${id}`
}

// 首页红包
export const firstRedpack = () => {
  return `/v1/newsapp/fireworks/${activity}/first_redpack`
}

// 获取基础信息接口
export const info = () => {
  return `/v1/newsapp/fireworks/${activity}/info`
}

// 获取新闻接口
export const news = () => {
  return `/v1/newsapp/fireworks/${activity}/news`
}

// 烟花人气榜接口
export const rank = () => {
  return `/v1/newsapp/fireworks/${activity}/rank`
}

// 获取指定烟花
export const material = (id: string) => {
  return `/v1/newsapp/fireworks/${activity}/get/${id}`
}

// 端外获取烟花信息接口
export const outMaterial = (id: string) => {
  return `/v1/newsapp/fireworks/${activity}/outer_get/${id}`
}

// 端外获取烟花模板信息
export const outTemplate = (inviteCode: string, id: string) => {
  return `/v1/newsapp/fireworks/${activity}/unlock_info/${inviteCode}/${id}`
}

// 随机获取一个烟花
export const randMaterial = () => {
  return `/v1/newsapp/fireworks/${activity}/rand_one`
}

// 烟花模板接口
export const tpl = () => {
  return `/v1/newsapp/fireworks/${activity}/idea`
}

// 提交创建烟花记录
export const create = (fid: string, nid: string, cid: string, pre: string, name: string) => {
  return `/v1/newsapp/fireworks/${activity}/make/${fid}/${nid}/${cid}/${pre}/${name}`
}

// 创建解锁稀有烟花
export const unlock = (id: string) => {
  return `/v1/newsapp/fireworks/${activity}/unlock_notify/${id}`
}

// 帮忙解锁稀有烟花
export const doUnlock = (uid: string, id: number) => {
  return `/v1/newsapp/fireworks/${activity}/unlock/${uid}/${id}`
}

// 烟花助力
export const boost = (fid: number) => {
  return `/v1/newsapp/fireworks/${activity}/boost/${fid}`
}

// 获取勋章接口
export const medal = () => {
  return `/v1/newsapp/fireworks/${activity}/get_medal`
}

// 红包雨提交接口
export const redpackNotify = (ename: string) => {
  return `/v1/newsapp/fireworks/${activity}/redpack_rain/notify/${ename}`
}

// 订阅红包雨
export const subPush = () => {
  return `/v1/newsapp/fireworks/${activity}/redpack_rain/subscribe`
}

// 我的烟花
export const record = () => {
  return `/v1/newsapp/fireworks/${activity}/myfw`
}

// 观看上报
export const reportfw = (id: string) => {
  return `/v1/newsapp/fireworks/${activity}/boost/${id}`
}

// 获取红包雨状态
export const redpackStaus = () => {
  return `/v1/newsapp/fireworks/${activity}/redpack_rain/status`
}

// 开始红包雨
export const redpackStart = () => {
  return `/v1/newsapp/fireworks/${activity}/redpack_rain/start`
}

// 第一次点击红包雨
export const redpackClick = (cycle: string) => {
  return `/v1/newsapp/fireworks/${activity}/redpack_rain/notify/${cycle}`
}

// 上报红包雨点击次数
export const redpackReport = (cycle: string, times: number) => {
  return `/v1/newsapp/fireworks/${activity}/redpack_rain/get/${cycle}?times=${times}`
}

// 获取勋章
export const getMedal = () => {
  return `/v1/newsapp/fireworks/${activity}/get_medal`
}

// 待领取红包数
export const rpCount = () => {
  return `/v1/newsapp/rp/pending_cnt`
}

// 短链接
export const createShortUrl = `https://api.prize.qq.com/v1/newsapp/shortUrl/generate?uiExpireTime=63072000`

// common
export const feconfig = () => {
  return `https://api.prize.qq.com/v1/newsapp/answer/other/config?actname=1225yanhua_downconfig`
}
